import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { RhNumberField } from '../../../../../../../../dum';
import { IOrderQuotation } from '../../../order-quotation-form';
import { useCalculateProductsTotal } from '../../../helpers/use-calculate-products-total';
import {
    GROUP_WEIGHT,
    GROUPS,
    KILOS,
    ORDER_QUOTATION_PRODUCTS,
    PRODUCT,
} from '../order-quotation-products-columns';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../../helpers';

export function GroupWeightInput({ index }: { index: number }) {
    const INPUT_NAME = `${ORDER_QUOTATION_PRODUCTS}.${index}.${GROUP_WEIGHT}`;
    // On a LINKED line the product owns the weight (filled and locked). On a
    // FREE line there is no product, so the weight is typed by hand — which is
    // how a free line still validates groups × group_weight === kilos.
    const product = useWatch({
        name: `${ORDER_QUOTATION_PRODUCTS}.${index}.${PRODUCT}`,
    }) as IOrderQuotation['order_quotation_products'][number]['product'];

    const formContext = useFormContext();
    const { calculateProductsTotal } = useCalculateProductsTotal();

    return (
        <RhNumberField
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.group_weight)}
            disableGutters
            disabled={!!product}
            onChange={(groupWeight) => {
                const groups = formContext.getValues(
                    `${ORDER_QUOTATION_PRODUCTS}.${index}.${GROUPS}`,
                ) as IOrderQuotation['order_quotation_products'][number]['groups'];
                formContext.setValue(
                    `${ORDER_QUOTATION_PRODUCTS}.${index}.${KILOS}`,
                    (groups ? Number(groups) : 0) *
                        (groupWeight ? Number(groupWeight) : 0),
                );
                calculateProductsTotal();
            }}
        />
    );
}
